import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import { DriverResponse, DriversDataPage } from "../../shared/backend-api.types";
import { apiPath } from "../../shared/api-path.const";
import { Driver } from "./driver.interface";

function toDriver(response: DriverResponse): Driver {
  return {
    id: response.driverId,
    userId: response.userId,
    base: response.baseLocation as Driver["base"],
    email: response.email,
    firstName: response.firstName,
    lastName: response.lastName,
    phoneNumber: response.phoneNumber,
  };
}

@Injectable({
  providedIn: "root",
})
export class DriverApiService {
  constructor(private readonly apiService: ApiService) {}

  public async getById(id: string): Promise<Driver> {
    const response = await this.apiService.sendGetRequest<DriverResponse>(`${apiPath.driver}/${id}`, undefined);
    return toDriver(response);
  }

  public async getByUserId(userId: string): Promise<Driver | undefined> {
    const response = await this.apiService.sendGetRequest<DriversDataPage, { userId: string }>(apiPath.driver, {
      userId,
    });
    return response.drivers.length > 0 ? toDriver(response.drivers[0]) : undefined;
  }

  public async search(name: string): Promise<Driver[]> {
    const response = await this.apiService.sendGetRequest<DriversDataPage, { search: string }>(apiPath.driver, {
      search: name,
    });
    return response.drivers.map(toDriver);
  }

  public async getByIds(ids: string[]): Promise<Driver[]> {
    if (ids.length === 0) return [];
    const response = await this.apiService.sendGetRequest<DriversDataPage, { ids: string }>(apiPath.driver, {
      ids: ids.join(","),
    });
    return response.drivers.map(toDriver);
  }
}
